import { classNames } from "../../utils"
import { Flex, type FlexProps } from "../Flex/Flex"

export type FlexColumnProps = FlexProps

export function FlexColumn({ className, ...rest }: FlexColumnProps) {
  return <Flex className={classNames("flex-col", className)} {...rest} />
}
